/* istanbul ignore file */
import {Id, LicenseLevel, ManifestLicensedFeature} from 'powtoon-versioning/src/currentSchema'

export enum LICENSED_FEATURE_IDS {
  LIPSYNC = 'feature-lipsync-001',
  CAMERA = 'feature-camera-001',
}

export const FEATURE_ASSET_TYPE = 'feature'
export const FEATURE_ITEM_TYPE = 'feature'

export type ApiLicensedFeature = {
  assetType: 'feature'
  itemType: 'feature'
  families: Id[]
  licenseLevel: LicenseLevel
  id: Id
}

export const isManifestLicensedFeature = (input: unknown):  input is ManifestLicensedFeature =>
  (input as ManifestLicensedFeature)?.assetType === 'feature' &&
  (input as ManifestLicensedFeature)?.itemType === 'feature'